var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module2, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", !isNodeMode && module2 && module2.__esModule ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// ../../node_modules/tsup/assets/cjs_shims.js
var init_cjs_shims = __esm({
  "../../node_modules/tsup/assets/cjs_shims.js"() {
  }
});

// ../../node_modules/lodash.mergewith/index.js
var require_lodash = __commonJS({
  "../../node_modules/lodash.mergewith/index.js"(exports, module2) {
    init_cjs_shims();
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var asyncTag = "[object AsyncFunction]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var nullTag = "[object Null]";
    var objectTag = "[object Object]";
    var proxyTag = "[object Proxy]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var undefinedTag = "[object Undefined]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var nativeObjectToString = objectProto.toString;
    var objectCtorString = funcToString.call(Object);
    var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var Symbol2 = root.Symbol;
    var Uint8Array2 = root.Uint8Array;
    var allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    var objectCreate = Object.create;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var splice = arrayProto.splice;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var nativeMax = Math.max;
    var nativeNow = Date.now;
    var Map2 = getNative(root, "Map");
    var nativeCreate = getNative(Object, "create");
    var baseCreate = function() {
      function object() {
      }
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    }();
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function Stack3(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    Stack3.prototype.clear = stackClear;
    Stack3.prototype["delete"] = stackDelete;
    Stack3.prototype.get = stackGet;
    Stack3.prototype.has = stackHas;
    Stack3.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assignMergeValue(object, key, value) {
      if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseAssignValue(object, key, value) {
      if (key == "__proto__" && defineProperty) {
        defineProperty(object, key, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key] = value;
      }
    }
    var baseFor = createBaseFor();
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object), result = [];
      for (var key in object) {
        if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack3());
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
          if (newValue === void 0) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
      var isCommon = newValue === void 0;
      if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
      return result;
    }
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    function copyArray(source, array) {
      var index = -1, length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1, length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? void 0 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    function initCloneObject(object) {
      return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
        return eq(object[index], value);
      }
      return false;
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    function safeGet(object, key) {
      if (key === "constructor" && typeof object[key] === "function") {
        return;
      }
      if (key == "__proto__") {
        return;
      }
      return object[key];
    }
    var setToString = shortOut(baseSetToString);
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArguments = baseIsArguments(function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });
    function constant(value) {
      return function() {
        return value;
      };
    }
    function identity(value) {
      return value;
    }
    function stubFalse() {
      return false;
    }
    module2.exports = mergeWith;
  }
});

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Checkbox: () => Checkbox,
  CheckboxGroup: () => CheckboxGroup,
  ChoiceChip: () => ChoiceChip,
  FormControl: () => FormControl,
  FormErrorMessage: () => import_react29.FormErrorMessage,
  FormHelperText: () => import_react29.FormHelperText,
  FormLabel: () => FormLabel,
  Input: () => Input,
  InputGroup: () => import_react29.InputGroup,
  InputLeftElement: () => InputLeftElement2,
  InputRightElement: () => InputRightElement2,
  PasswordInput: () => PasswordInput,
  Radio: () => Radio,
  RadioGroup: () => RadioGroup,
  SearchInput: () => SearchInput,
  Select: () => Select,
  Switch: () => Switch,
  Textarea: () => Textarea
});
init_cjs_shims();
var import_react29 = require("@chakra-ui/react");

// src/Checkbox.tsx
init_cjs_shims();
var import_react = require("@chakra-ui/react");
var import_react2 = __toESM(require("react"));
var Checkbox = (0, import_react.forwardRef)((props, ref) => {
  return /* @__PURE__ */ import_react2.default.createElement(import_react.Checkbox, __spreadProps(__spreadValues({}, props), {
    ref
  }));
});

// src/CheckboxGroup.tsx
init_cjs_shims();
var import_react3 = require("@chakra-ui/react");
var import_react4 = __toESM(require("react"));
var CheckboxGroup = (_a) => {
  var _b = _a, {
    direction = "row",
    children
  } = _b, props = __objRest(_b, [
    "direction",
    "children"
  ]);
  return /* @__PURE__ */ import_react4.default.createElement(import_react3.CheckboxGroup, __spreadValues({}, props), /* @__PURE__ */ import_react4.default.createElement(import_react3.Stack, {
    direction
  }, children));
};

// src/ChoiceChip.tsx
init_cjs_shims();
var import_react5 = require("@chakra-ui/react");

// ../../node_modules/@chakra-ui/utils/dist/chakra-ui-utils.esm.js
init_cjs_shims();
var import_lodash = __toESM(require_lodash());

// ../../node_modules/framesync/dist/es/index.js
init_cjs_shims();

// ../../node_modules/framesync/dist/es/on-next-frame.js
init_cjs_shims();
var defaultTimestep = 1 / 60 * 1e3;

// ../../node_modules/framesync/dist/es/create-render-step.js
init_cjs_shims();

// ../../node_modules/@chakra-ui/utils/dist/chakra-ui-utils.esm.js
var __DEV__ = process.env.NODE_ENV !== "production";
var __TEST__ = process.env.NODE_ENV === "test";
function get(obj, path, fallback, index) {
  var key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = function memoize2(fn) {
  var cache = /* @__PURE__ */ new WeakMap();
  var memoizedFn = function memoizedFn2(obj, path, fallback, index) {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    var map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    var value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var isBrowser = canUseDOM();
var dataAttr = function dataAttr2(condition) {
  return condition ? "" : void 0;
};
var focusableElList = ["input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "embed", "iframe", "object", "a[href]", "area[href]", "button:not([disabled])", "[tabindex]", "audio[controls]", "video[controls]", "*[tabindex]:not([aria-disabled])", "*[contenteditable]"];
var focusableElSelector = focusableElList.join();
function once(fn) {
  var result;
  return function func() {
    if (fn) {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      result = fn.apply(this, args);
      fn = null;
    }
    return result;
  };
}
var warn = once(function(options) {
  return function() {
    var condition = options.condition, message = options.message;
    if (condition && __DEV__) {
      console.warn(message);
    }
  };
});
var error = once(function(options) {
  return function() {
    var condition = options.condition, message = options.message;
    if (condition && __DEV__) {
      console.error(message);
    }
  };
});
var minSafeInteger = Number.MIN_SAFE_INTEGER || -9007199254740991;
var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;
var breakpoints = Object.freeze(["base", "sm", "md", "lg", "xl", "2xl"]);

// src/ChoiceChip.tsx
var import_spor_icon_react = require("@vygruppen/spor-icon-react");
var import_react6 = __toESM(require("react"));
var ChoiceChip = (0, import_react5.forwardRef)((props, ref) => {
  const {
    children,
    icon,
    size = "md",
    variant = "choice"
  } = props;
  const {
    state,
    getInputProps,
    getCheckboxProps,
    getRootProps,
    getLabelProps
  } = (0, import_react5.useCheckbox)(props);
  const styles = (0, import_react5.useMultiStyleConfig)("ChoiceChip", {
    size,
    variant,
    icon,
    hasLabel: Boolean(children)
  });
  return /* @__PURE__ */ import_react6.default.createElement(import_react5.chakra.label, __spreadValues({}, getRootProps()), /* @__PURE__ */ import_react6.default.createElement(import_react5.chakra.input, __spreadValues({}, getInputProps({}, ref))), /* @__PURE__ */ import_react6.default.createElement(import_react5.chakra.div, __spreadProps(__spreadValues({}, getLabelProps()), {
    __css: styles.container,
    "data-checked": dataAttr(state.isChecked),
    "data-hover": dataAttr(state.isHovered),
    "data-focus": dataAttr(state.isFocused)
  }), icon && /* @__PURE__ */ import_react6.default.createElement(import_react5.chakra.span, {
    __css: styles.icon
  }, state.isChecked ? icon.checked : icon.default), /* @__PURE__ */ import_react6.default.createElement(import_react5.chakra.span, __spreadValues({
    __css: styles.label
  }, getCheckboxProps()), variant !== "icon" && children), variant === "filter" && state.isChecked && /* @__PURE__ */ import_react6.default.createElement(import_spor_icon_react.CloseOutline24Icon, {
    ml: 1.5
  })));
});

// src/FormControl.tsx
init_cjs_shims();
var import_react7 = require("@chakra-ui/react");
var import_react8 = __toESM(require("react"));
var FormControl = (props) => {
  return /* @__PURE__ */ import_react8.default.createElement(import_react7.FormControl, __spreadValues({}, props));
};

// src/FormLabel.tsx
init_cjs_shims();
var import_react9 = require("@chakra-ui/react");
var import_react10 = __toESM(require("react"));
var FormLabel = (props) => {
  return /* @__PURE__ */ import_react10.default.createElement(import_react9.FormLabel, __spreadValues({}, props));
};

// src/Input.tsx
init_cjs_shims();
var import_react11 = require("@chakra-ui/react");
var import_react12 = __toESM(require("react"));
var Input = (0, import_react11.forwardRef)((_a, ref) => {
  var _b = _a, { label, leftIcon, rightIcon, id } = _b, props = __objRest(_b, ["label", "leftIcon", "rightIcon", "id"]);
  return /* @__PURE__ */ import_react12.default.createElement(import_react11.InputGroup, {
    position: "relative"
  }, leftIcon && /* @__PURE__ */ import_react12.default.createElement(import_react11.InputLeftElement, null, leftIcon), /* @__PURE__ */ import_react12.default.createElement(import_react11.Input, __spreadProps(__spreadValues({
    pl: leftIcon ? 7 : void 0,
    pr: rightIcon ? 7 : void 0,
    id
  }, props), {
    ref,
    placeholder: " "
  })), /* @__PURE__ */ import_react12.default.createElement(import_react11.FormLabel, {
    htmlFor: id,
    pointerEvents: "none"
  }, label), rightIcon && /* @__PURE__ */ import_react12.default.createElement(import_react11.InputRightElement, null, rightIcon));
});

// src/InputElement.tsx
init_cjs_shims();
var import_react13 = require("@chakra-ui/react");
var import_react14 = __toESM(require("react"));
var InputLeftElement2 = (props) => /* @__PURE__ */ import_react14.default.createElement(import_react13.InputLeftElement, __spreadValues({}, props));
var InputRightElement2 = (props) => /* @__PURE__ */ import_react14.default.createElement(import_react13.InputRightElement, __spreadValues({}, props));

// src/PasswordInput.tsx
init_cjs_shims();
var import_react15 = require("@chakra-ui/react");
var import_spor_i18n_react = require("@vygruppen/spor-i18n-react");
var import_react16 = __toESM(require("react"));
var PasswordInput = (0, import_react15.forwardRef)((_a, ref) => {
  var _b = _a, { leftIcon, id, label } = _b, props = __objRest(_b, ["leftIcon", "id", "label"]);
  const { isOpen: isShowingPassword, onToggle } = (0, import_react15.useDisclosure)();
  const { t } = (0, import_spor_i18n_react.useTranslation)();
  return /* @__PURE__ */ import_react16.default.createElement(import_react29.InputGroup, {
    position: "relative"
  }, leftIcon && /* @__PURE__ */ import_react16.default.createElement(InputLeftElement2, null, leftIcon), /* @__PURE__ */ import_react16.default.createElement(import_react15.Input, __spreadProps(__spreadValues({}, props), {
    placeholder: " ",
    type: isShowingPassword ? "text" : "password",
    pr: 10,
    pl: leftIcon ? 7 : void 0,
    ref
  })), /* @__PURE__ */ import_react16.default.createElement(FormLabel, {
    htmlFor: id,
    pointerEvents: "none"
  }, label), /* @__PURE__ */ import_react16.default.createElement(InputRightElement2, {
    width: "fit-content"
  }, /* @__PURE__ */ import_react16.default.createElement(import_react15.Button, {
    variant: "ghost",
    type: "button",
    onClick: onToggle,
    borderRadius: "sm",
    mr: 1
  }, isShowingPassword ? t(texts.hidePassword) : t(texts.showPassword))));
});
var texts = {
  showPassword: {
    nb: "Vis",
    en: "Show",
    sv: "Visa"
  },
  hidePassword: {
    nb: "Skjul",
    en: "Hide",
    sv: "D\xF6lj"
  }
};

// src/Radio.tsx
init_cjs_shims();
var import_react17 = require("@chakra-ui/react");
var import_react18 = __toESM(require("react"));
var Radio = (props) => {
  return /* @__PURE__ */ import_react18.default.createElement(import_react17.Radio, __spreadValues({}, props));
};

// src/RadioGroup.tsx
init_cjs_shims();
var import_react19 = require("@chakra-ui/react");
var import_react20 = __toESM(require("react"));
var RadioGroup = (_a) => {
  var _b = _a, {
    children,
    direction = "row"
  } = _b, rest = __objRest(_b, [
    "children",
    "direction"
  ]);
  return /* @__PURE__ */ import_react20.default.createElement(import_react19.RadioGroup, __spreadValues({}, rest), /* @__PURE__ */ import_react20.default.createElement(import_react19.Stack, {
    direction
  }, children));
};

// src/Select.tsx
init_cjs_shims();
var import_react21 = require("@chakra-ui/react");
var import_react22 = __toESM(require("react"));
var Select = (_a) => {
  var _b = _a, { label } = _b, props = __objRest(_b, ["label"]);
  const styles = (0, import_react21.useMultiStyleConfig)("Select", props);
  return /* @__PURE__ */ import_react22.default.createElement(FormControl, null, /* @__PURE__ */ import_react22.default.createElement(import_react21.Select, __spreadProps(__spreadValues({}, props), {
    rootProps: { __css: styles.root }
  })), label && /* @__PURE__ */ import_react22.default.createElement(FormLabel, null, label));
};

// src/Switch.tsx
init_cjs_shims();
var import_react23 = require("@chakra-ui/react");
var import_react24 = __toESM(require("react"));
var Switch = (_a) => {
  var _b = _a, {
    variant = "solid",
    size = "md"
  } = _b, props = __objRest(_b, [
    "variant",
    "size"
  ]);
  return /* @__PURE__ */ import_react24.default.createElement(import_react23.Switch, __spreadValues({
    variant,
    size
  }, props));
};

// src/Textarea.tsx
init_cjs_shims();
var import_react25 = require("@chakra-ui/react");
var import_react26 = __toESM(require("react"));
var Textarea = (0, import_react25.forwardRef)((props, ref) => {
  const {
    spacingProps,
    remainingProps: _a
  } = getSpacingProps(props), _b = _a, { label } = _b, rest = __objRest(_b, ["label"]);
  return /* @__PURE__ */ import_react26.default.createElement(import_react25.Box, __spreadValues({}, spacingProps), /* @__PURE__ */ import_react26.default.createElement(import_react25.FormLabel, null, label), /* @__PURE__ */ import_react26.default.createElement(import_react25.Textarea, __spreadProps(__spreadValues({}, rest), {
    ref
  })));
});
function getSpacingProps(props) {
  const _a = props, {
    mt,
    mr,
    mb,
    ml,
    mx,
    my,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    marginX,
    marginY,
    pt,
    pr,
    pb,
    pl,
    px,
    py,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    paddingX,
    paddingY
  } = _a, remainingProps = __objRest(_a, [
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
  ]);
  return {
    spacingProps: {
      mt,
      mr,
      mb,
      ml,
      mx,
      my,
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
      marginX,
      marginY,
      pt,
      pr,
      pb,
      pl,
      px,
      py,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingX,
      paddingY
    },
    remainingProps
  };
}

// src/SearchInput.tsx
init_cjs_shims();
var import_react27 = require("@chakra-ui/react");
var import_spor_i18n_react2 = require("@vygruppen/spor-i18n-react");
var import_spor_icon_react2 = require("@vygruppen/spor-icon-react");
var import_react28 = __toESM(require("react"));
var SearchInput = (0, import_react27.forwardRef)((_a, ref) => {
  var _b = _a, { label, onReset } = _b, props = __objRest(_b, ["label", "onReset"]);
  const { t } = (0, import_spor_i18n_react2.useTranslation)();
  const showCloseButton = onReset && Boolean(props.value);
  return /* @__PURE__ */ import_react28.default.createElement(import_react29.InputGroup, {
    position: "relative"
  }, /* @__PURE__ */ import_react28.default.createElement(InputLeftElement2, null, /* @__PURE__ */ import_react28.default.createElement(import_spor_icon_react2.SearchOutline24Icon, null)), /* @__PURE__ */ import_react28.default.createElement(import_react27.Input, __spreadProps(__spreadValues({
    pl: 7,
    pr: 7
  }, props), {
    type: "search",
    css: {
      "&::-webkit-search-cancel-button": {
        WebkitAppearance: "none"
      }
    },
    ref,
    placeholder: " "
  })), /* @__PURE__ */ import_react28.default.createElement(FormLabel, {
    htmlFor: props.id,
    pointerEvents: "none"
  }, label != null ? label : t(texts2.label)), showCloseButton && /* @__PURE__ */ import_react28.default.createElement(InputRightElement2, {
    width: "fit-content"
  }, /* @__PURE__ */ import_react28.default.createElement(import_react27.IconButton, {
    variant: "ghost",
    type: "button",
    size: "sm",
    mr: 1,
    "aria-label": t(texts2.reset),
    icon: /* @__PURE__ */ import_react28.default.createElement(import_spor_icon_react2.CloseOutline24Icon, null),
    onClick: onReset
  })));
});
var texts2 = {
  label: {
    [import_spor_i18n_react2.Language.NorwegianBokmal]: "S\xF8k",
    [import_spor_i18n_react2.Language.Swedish]: "S\xF6k",
    [import_spor_i18n_react2.Language.English]: "Search"
  },
  reset: {
    [import_spor_i18n_react2.Language.NorwegianBokmal]: "T\xF8m s\xF8kefeltet",
    [import_spor_i18n_react2.Language.Swedish]: "Rensa s\xF6krutan",
    [import_spor_i18n_react2.Language.English]: "Reset search field"
  }
};
module.exports = __toCommonJS(src_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Checkbox,
  CheckboxGroup,
  ChoiceChip,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  PasswordInput,
  Radio,
  RadioGroup,
  SearchInput,
  Select,
  Switch,
  Textarea
});
